<template>
	<section class="scanner-grid-section">
		<Row class="">
			<Container class="flex flex-wrap items-center">
				<h2
					id="scanner-pitch-title"
					class="text-white text-[32px] lg:text-6xl font-medium mb-[32px] lg:mb-[64px] text-center w-full max-w-[848px] text-center mx-auto"
				>
					Stay Ahead of the Curve with our AI and Algorithm-Enhanced Tools
				</h2>
				<div class="flex flex-wrap justify-between gap-x-10 gap-y-10">
					<scanner-small
						scanner-class="scanner scanner-small bg-semi-light"
						title-class="scanner-title text-black"
						paragraph-class="text-black"
						title="Silver Dollar Club"
						class="!text-left"
						description="StocksToTrade lead trainer Tim Bohen built this algorithm around one repeatable market event. The moment a stock crosses $1, five forces converge to create a potential breakout. Rubicon finds these setups daily and hands you a simple buy, hold, or sell signal."
						button-link="https://sttlive.io/biGpYY"
						button-class="w-full lg:w-auto justify-center"
						:button-type="ctaAppearence || 'gradient-dark'"
						button-text="View Pricing"
						img-id="scanner-pitch-2-img"
						img-src="/images/tmbohen-silver.webp"
						img-alt="tmbohen-silver.webp"
						:img-width="572"
						:img-height="264"
					/>
					<scanner-small
						scanner-class="scanner scanner-small bg-dark"
						title-class="scanner-title text-white"
						paragraph-class="text-white"
						title="IRIS Analytics"
						description="StocksToTrade lead trainer Tim Bohen designed this AI system around his meticulous trading style — it's able to forecast explosive stock moves days and even weeks into the future!"
						button-link="https://sttlive.io/V0kmjQ"
						button-class="w-full lg:w-auto justify-center"
						:button-type="ctaAppearence || 'gradient-light'"
						button-text="View Pricing"
						img-id="scanner-pitch-3-img"
						img-src="/images/scanner-grid-3.webp"
						img-alt="scanner-grid-3.webp"
						:img-width="572"
						:img-height="264"
					/>
				</div>
			</Container>
		</Row>
	</section>
</template>

<script setup>
const { ctaAppearence } = defineProps({
	ctaAppearence: { type: String }
});

const isDesktop = ref(false);

const breakpoints = reactive(
	useBreakpoints({
		small: 768
	})
);

onMounted(async () => {
	if (import.meta.client && breakpoints.isGreater("small")) {
		isDesktop.value = true;
	}
});
</script>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;

.scanner-grid-section {
	.full-width {
		width: 100%;
	}

	.scanner {
		min-height: 100px;
		border-radius: 16px;
		padding: 32px 0 0 20px;
		text-align: left;
		position: relative;
		overflow: hidden;
		@include breakpoint(lg) {
			padding: 32px 0 0 32px;
			max-height: 540px;
		}
		img {
			border-radius: 8px 0px 0px 0px;
			margin-left: auto;
			margin-bottom: -12px;

			@include breakpoint(lg) {
				border-radius: 16px 0px 0px 0px;
			}
		}

		&-big {
			padding-top: 120px;
			padding-bottom: 24px;

			@include breakpoint(lg) {
				padding-bottom: 100px;
			}
			&-image {
				right: -16px;
				bottom: 0;
				left: 40px;
				position: relative;
				top: 24px;

				@include breakpoint(lg) {
					width: 904px;
					position: absolute;
					min-height: 380px;
					max-height: 380px;
					left: auto;
					top: 64px;
				}
			}

			@media only screen and (max-width: 768px) {
				padding-top: 32px;
				padding-bottom: 0;
			}
		}

		&-small {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			@media only screen and (max-width: 768px) {
				width: 100%;
				flex: auto !important;
			}
		}

		&-title {
			font-family: Open Sauce Sans;
			font-size: 32px;
			font-weight: 500;
			line-height: 35px;
			letter-spacing: -2px;
			text-align: left;
		}
		&-paragraph {
			font-family: DM Sans;
			font-size: 18px;
			font-weight: 400;
			line-height: 27px;
			letter-spacing: 0px;
			text-align: left;
		}
	}

	.half-width {
		flex: 1;
	}

	.bg-light {
		background: linear-gradient(167.41deg, #c3b9ff 19.11%, #364bbc 69.51%);
	}

	.bg-semi-light {
		background: linear-gradient(107.69deg, #87c7f5 15.06%, #c464ff 89.01%);
	}

	.bg-dark {
		background: linear-gradient(110.32deg, #091d56 8.05%, #331290 77.58%);
	}
}

#scanner-pitch-1-img {
	@include breakpoint(lg) {
		// opacity: 0;
		right: -224px;
	}
}
</style>
